// API documentation
export const API = {

    // Inbox
    inboxCount: 'hrms|master|inbox|count',
    inboxAttendance: 'hrms|master|inbox|attendance|list',
    inboxEmployeeExit: 'hrms|master|inbox|employeeExitRequest|list',
    inboxEmployeeExitTaskList: 'hrms|master|inbox|FF|settlement|user|task|list',
    inboxLeave: 'hrms|master|inbox|leave|list',
    inboxEncahsment: 'hrms|master|inbox|leaveEncashment|list',
    inboxTaxRegime: 'hrms|payroll|employee|financialYear|setting|taxRegime|inboxRequest|list',
    inboxBonusDeduction: 'hrms|payroll|bouns_deduction|read',
    inboxShiftRequest: 'hrms|master|inbox|shiftRequest|list',
    inboxHolidayRequest: 'hrms|master|inbox|holiday|list',
    inboxOvertime: 'hrms|master|inbox|overtime|list',
    inboxOnDuty: 'hrms|master|inbox|onDutyRequest|list',
    inboxProfile: 'hrms|master|inbox|profileRequest|list',
    inboxCompOff: 'hrms|master|inbox|compOffRequest|list',
    inboxFeedback: 'hrms|master|inbox|feedbackRequest|list',
    inboxSurvey: 'survey|survey|user|indox',
    onboardingTask: 'hrms|master|inbox|onboarding|list',
    inboxGetFeedback: 'hrms|employee|feedbackRequest|fetch',
    inboxGiveFeedback: 'hrms|employee|feedback|write',
    reimbursementRequest: 'hrms|payroll|reimbursement|inbox|count',
    reimbursementRequestSkip: 'survey|template|question|answer|skip',
    documentRequest:'hrms|master|inbox|documentRequest|list',
    FFSettlementRequest:'hrms|master|inbox|FF|settlement|request|list',
    incomeTaxRequest:'hrms|payroll|taxRegime|user|inbox',
    expenseRequest:'hrms|expense|read',

    // Praise settings - Badge
    readBadge: 'hrms|employee|badge|read',
    readFeedBack: 'hrms|employee|feedback|badge|read',
    createBadge: 'hrms|employee|badge|create',
    updateBadge: 'hrms|employee|badge|update',
    deleteBadge: 'hrms|employee|badge|delete',
    getBadge: 'hrms|employee|badge|getbyId',

    // Praise settings - Core Value
    readCoreValue: 'hrms|employee|coreValue|read',
    createCoreValue: 'hrms|employee|coreValue|create',
    updateCoreValue: 'hrms|employee|coreValue|update',
    deleteCoreValue: 'hrms|employee|coreValue|delete',

    // Profile - Commom - User Custom Fields
    userCustomFieldsRead: 'hrms|master|customFieldsData|read',
    // Profile - Personal - Basic Info
    employeeRead: 'hrms|employee|read',
    employeeUpdate: 'hrms|employee|update',

    // Profile - Praise
    addPraise: 'hrms|announcement|praise|create',
    editPraise: 'hrms|announcement|praise|update',
    getBadgeList: 'hrms|employee|badge|list',
    getFeedbacktypeList: 'hrms|employee|feedback|badge|list',
    getSelectionList: 'hrms|announcement|dropList|userTagList',
    readPraise: 'hrms|announcement|praise|read',
    deletePraise: 'hrms|announcement|post|delete',
    archivePraise: 'hrms|announcement|praise|archive',

    // Profile - Feedback
    addFeedback: 'hrms|employee|feedback|create',
    editFeedback: 'hrms|employee|feedback|update',
    getCoreValueList: 'hrms|employee|coreValue|list',
    readFeedback: 'hrms|employee|feedback|read',
    deleteFeedback: 'hrms|employee|feedback|delete',
    archiveFeedback: 'hrms|employee|feedback|archive',

    // Profile - Request Feedback
    requestFeedback: 'hrms|employee|feedback|request',
    requestUpdateFeedback: 'hrms|employee|feedback|requestUpdate',
    readFeedbackRequests: 'hrms|employee|feedback|read',
    deleteFeedbackRequests: 'hrms|employee|feedback|delete',
    archiveFeedbackRequests: 'hrms|employee|feedback|archive',
    feedbackUsers: 'hrms|announcement|dropList|userList',

    // Profile - Internal Notes
    readInternalNotes: 'hrms|employee|internalNotes|read',
    addInternalNote: 'hrms|employee|internalNotes|create',
    editInternalNote: 'hrms|employee|internalNotes|update',
    deleteInternalNote: 'hrms|employee|internalNotes|delete',

    // Profile - Activity Timeline
    readActivityTimeline: 'hrms|employee|activityLog',

    // Announcement Reaction
    reactOnPost: 'hrms|announcement|reaction',
    postLikes: 'hrms|announcement|feed|userAction',
    postVotes: 'hrms|announcement|poll|voteUsers',

    listComment:'hrms|announcement|post|listComments',
    addComment: 'hrms|announcement|post|comment',
    editComment: 'hrms|announcement|post|updateComment',
    deleteComment:'hrms|announcement|post|deleteComment',
}
